import { type GetStateFunc } from './store'

export const ActionUtil = {
  getToken
}

/**
 * Helper function to fetch authentication token from state.
 * @param getState 'getState' redux function.
 * @param actionName name of the associated action (for logging purposes).
 */
function getToken(getState: GetStateFunc, actionName: string): string | null {
  const state = getState()
  const { idToken } = state.auth

  if (idToken === '') {
    console.info(`cancelling action '${actionName}' - no auth token available`)
  }

  return idToken
}
